import { httpMethod } from "../../enum/httpMethod";
// action types
export const API_REQUEST = "API_REQUEST";
export const API_SUCCESS = "API_SUCCESS";
export const API_ERROR = "API_ERROR";

// action creators
export const apiRequest = (
  body: any,
  method: httpMethod,
  url: string,
  feature: any,
  token?: string,
  dispatch?: any,
  callback?: (res: any, err?: any) => void
) => ({
  type: `${feature} ${API_REQUEST}`,
  payload: body,
  meta: { body, method, url, feature, token },
  callback: callback,
  dispatch: dispatch,
});

export const apiSuccess = (response: any, feature: any) => ({
  type: `${feature} ${API_SUCCESS}`,
  payload: response,
  meta: { feature },
});

export const apiError = (error: any, feature: any) => ({
  type: `${feature} ${API_ERROR}`,
  payload: error,
  meta: { feature, event },
});
